import React, { useRef, useState } from 'react';
import bem from 'utils/bem';
import Popover from '@mui/material/Popover';
import InlineDateTimeField from './InlineDateTimeField';
import { useMobile } from 'utils/media';
import { Dialog } from '@mui/material';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { Button } from 'components/Button';

const { block, el } = bem('datetime-field', 'dialog-datetime-field');
const MobileDialogDateTimeField = ({ className, anchorEl, open, onClose, Field = null, text, ...rest }) => {

    const [ saveDisabled, setSaveDisabled ] = useState(true);

    const classes = {
        paper: el('paper')
    };

    const InlineField = Field ? Field : InlineDateTimeField;

    return (
        <div className={block()}>
            <Dialog
                className={el('dialog')}
                open={open}
                onClose={onClose}
                fullWidth={ true }
                fullScreen={ true }
                classes={classes}
                maxWidth={ 'md' }
            >
                <div className={el('header')}>
                    <div className={el('title')}>
                        <Text serif>{text}</Text>
                    </div>
                    <div className={el('close')} onClick={onClose}>
                        <Icon name={'x'} />
                    </div>
                </div>
                <InlineField {...rest} setSaveDisabled={setSaveDisabled} />
                <div className={el('save')}>
                    <Button mod={'gold'} onClick={onClose} disabled={saveDisabled}><Text>Сохранить</Text></Button>
                </div>
            </Dialog>
        </div>
    );
};

export default MobileDialogDateTimeField;



